import { type App } from 'vue';
import { registerPartials } from '@precon-tools-suite-by-shared/vue-partials';

// Import the global options.
import { type GinoProcurementsGlobalOptions } from './options';

export { default as ProductPredicateContext } from './components/ProductPredicateContext.vue';
export { default as SupplierbranchSelectTable } from './components/SupplierbranchSelectTable.vue';
export { default as ProductCategoriesMessage } from './components/ProductCategoriesMessage.vue';
export { default as ProductSupplierbranchesMessage } from './components/ProductSupplierbranchesMessage.vue';
export { default as ProductWhereClauseBuilder } from './components/ProductWhereClauseBuilder.vue';

// Export the
export type { GinoProcurementsGlobalOptions };
export { default as routes } from './routes';

// Export the helpers that you want to use outside of this library.
export { useListOverflow } from './helpers/list';

// Export the composables that you want to use outside of this library.
export * from './composables/useGinoProcurements';
export * from './composables/useProductPredicates';
export * from './composables/useNodesToNames';

export { type AnswerProductPredicateMutationVariables } from './composables/useProductPredicates.generated';

// Import/Export the components that you want to use outside of this library.

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartials(
            app,
            {
                CreateProduct: () => import('./partials/CreateProduct.vue'),
                UpdateProduct: () => import('./partials/UpdateProduct.vue'),
                CategorizeProduct: () =>
                    import('./partials/CategorizeProduct.vue'),
                CategorizeManyProducts: () =>
                    import('./partials/CategorizeManyProducts.vue'),
                SetStatusManyProducts: () =>
                    import('./partials/SetStatusManyProducts.vue'),
                CreateSupplier: () => import('./partials/CreateSupplier.vue'),
                UpdateSupplier: () => import('./partials/UpdateSupplier.vue'),
                CreateSupplierbranch: () =>
                    import('./partials/CreateSupplierbranch.vue'),
                UpdateSupplierbranch: () =>
                    import('./partials/UpdateSupplierbranch.vue'),
                SetStatusManyBranches: () =>
                    import('./partials/SetStatusManyBranches.vue'),

                SupplierbranchProducts: () =>
                    import('./partials/SupplierbranchProducts.vue'),
            },
            '@precon-tools-suite-by-shared/gino-procurements-feature/partials/'
        );
    },
};
